import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { ReactNode } from 'react';

/**
 * Envuelve rutas que requieren login. Si no hay user, redirige a /login
 * preservando la URL deseada en state para volver despues.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { ready, user } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <span className="text-ash text-sm">Bancá un toque…</span>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/**
 * Envuelve rutas publicas que NO deberia ver un usuario logueado (login/signup).
 * Si hay user, redirige a /app.
 */
export function RedirectIfAuth({ children }: { children: ReactNode }) {
  const { ready, user } = useAuth();
  if (!ready) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <span className="text-ash text-sm">Bancá un toque…</span>
      </main>
    );
  }
  if (user) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
